<p-drawer [style]="{'width':'min-content'}" position="right" [(visible)]="sidebarVisible" (onHide)="back()">
  <div class="pt-3">
    <router-outlet></router-outlet>
  </div>
</p-drawer>


